var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1283 2.57189L24.1583 2.77942C23.8683 1.6899 23.0853 0.849191 22.0903 0.543191L22.0693 0.537897C20.1984 1.45155e-05 12.6694 1.4633e-05 12.6694 1.4633e-05C12.6694 1.4633e-05 5.15954 -0.0105737 3.26956 0.537897C2.25558 0.84919 1.47159 1.6899 1.18659 2.75719L1.18159 2.77942C0.482598 6.64519 0.477598 11.2902 1.21259 15.4292L1.18159 15.2195C1.47159 16.3091 2.25458 17.1498 3.24956 17.4558L3.27056 17.4611C5.13954 18 12.6704 18 12.6704 18C12.6704 18 20.1794 18 22.0703 17.4611C23.0853 17.1498 23.8693 16.3091 24.1543 15.2418L24.1593 15.2195C24.4773 13.4217 24.6593 11.3527 24.6593 9.2393C24.6593 9.16201 24.6593 9.08365 24.6583 9.0053C24.6593 8.9333 24.6593 8.84754 24.6593 8.76177C24.6593 6.6473 24.4773 4.57836 24.1283 2.57189ZM10.2675 12.8658V5.14378L16.5334 9.0106L10.2675 12.8658Z",
    fill: "#EBBC13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.c801c6dc0835222e07309cf6ec97e5cc.svg";
export { ForwardRef as ReactComponent };